import { render, staticRenderFns } from "./AddTable.vue?vue&type=template&id=7450cdbe&scoped=true&"
import script from "./AddTable.vue?vue&type=script&lang=js&"
export * from "./AddTable.vue?vue&type=script&lang=js&"
import style0 from "./AddTable.vue?vue&type=style&index=0&id=7450cdbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7450cdbe",
  null
  
)

export default component.exports